import { render, staticRenderFns } from "./UploadWeightModal.vue?vue&type=template&id=27ac3f7e"
import script from "./UploadWeightModal.vue?vue&type=script&lang=js"
export * from "./UploadWeightModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports